const doc = [({"da":({"js":({"admin":({"routes":({"contact_relationships":({"edit":({"the_relationship_was_saved":"Relationen blev gemt."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;